'use strict';

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import {JwtHelper} from 'angular2-jwt';

@Injectable()
export class AuthService {
    isLoggedIn = false;
    redirectUrl: string;
    private jwtHelper: JwtHelper = new JwtHelper();

    login(): Observable<boolean> {
        return Observable.of(true).delay(1000).do(val => {
            this.isLoggedIn = true;
        });
    }

    logout(): void {
        this.isLoggedIn = false;
    }

    isAuthenticated(): boolean {
        if (localStorage.getItem('userToken'))
            return !this.jwtHelper.isTokenExpired(localStorage.getItem('userToken'));

        return false;
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/auth/auth.service.ts